import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insurence-carrier',
  templateUrl: './insurence-carrier.component.html',
  styleUrls: ['./insurence-carrier.component.css']
})
export class InsurenceCarrierComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
